/**
 * @generated SignedSource<<8b97c7c6bc36e2552f79919d3dfa0015>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ModalStepOutlet_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddOrReplacePlayerPrivateStep_Booking" | "AddPlayerStep_Booking" | "EditableRoundsStep_Booking">;
  readonly " $fragmentType": "ModalStepOutlet_Booking";
};
export type ModalStepOutlet_Booking$key = {
  readonly " $data"?: ModalStepOutlet_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ModalStepOutlet_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ModalStepOutlet_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditableRoundsStep_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddPlayerStep_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddOrReplacePlayerPrivateStep_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "46fe8167658fc051b82f0cb29401e05b";

export default node;
